import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large ContractTypesActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить тип договора ${_ctx.state.name}?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full",
        placeholder: "Название",
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors,
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_select, {
        class: "w-full mt-3",
        placeholder: "Видим для ролей",
        "is-invalid": _ctx.state_form$.roleIds.$error,
        "validation-errors": _ctx.state_form$.roleIds.$errors,
        loading: _ctx.data_state.roles.is_loading,
        failed: _ctx.data_state.roles.is_failed,
        options: _ctx.data_state.roles.list,
        "error-text": "При получении списка ролей произошла ошибка",
        "infinite-scroll": "",
        multiselect: "",
        value: _ctx.state.roleIds,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.roleIds) = $event)),
        onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadRoles(_ctx.data_state.roles.pagination.current_page))),
        onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreRoles(_ctx.data_state.roles.pagination.current_page + 1))),
        onSearch: _ctx.searchRoles,
        onOptionBySearch: _ctx.unshiftFindedRole
      }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_checkbox, {
        class: "mt-2",
        label: "Основной",
        value: _ctx.state.isMain,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.isMain) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        class: "mt-2",
        label: "Конфиденциальный",
        value: _ctx.state.isConfidential,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.isConfidential) = $event))
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "confirm-message", "is-confirm", "loading", "onCancel", "onConfirm"]))
}